import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight, faPlay } from '@fortawesome/free-solid-svg-icons';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';
import PlusIcon from '../../../../images/plus.svg';
import ShapeLeft from '../../../../images/ShapeLeft.svg';
import ShapeRight from '../../../../images/ShapeRight.svg';
import FirstPage from '../../../../images/firstPageIcon.svg';
import LastPage from '../../../../images/lastPageIcon.svg';
import {base_url} from '../../../Common/api';





var url =  window.location.hostname;
var port = window.location.port;
// const Heading = [['ID', 'Warehouse', 'Brand', 'Area Code','Nearby Area Code' ]]
const Heading = [['ID', 'Area Code','Nearby Area Code' ]]




class TaxMaster extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);


    this.state = {
    loading_overlay: false, 
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      startCount: 0,
      endCount: 0,
      showInvalidItem: false,
      isDownloading: false,
      entriesPerPage: 10,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      showResponseData: false,
      showBaseResponseData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      startIndex: 0,
      endIndex: 0,
      loadingText: 'Loading...',
  
    };
  }


  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

 

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  viewMappedItem =()=>{
    window.location.href = '/upload/view_mapped_items'
  }

  viewItem = (taxGroup)=>{
    
    window.location.href = '/upload/view_tax_items_details?tax_group='+taxGroup;
  }

  createTaxGroup = ()=>{
    window.location.href = '/upload/create_tax_group'
  }


  handleSearchInput = (e) => {
    const searchValue = e.target.value;
    this.setState({ searchTerm: searchValue }); // optional, for reuse in pagination
    if(searchValue == ""){
      this.fetchBinData(1, searchValue);
    }
     
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.fetchBinData(1, this.state.searchTerm);
    }
  };
 

  fetchBinData(page = 1, searchTerm = ''){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true,
        isDownloading: false,
      })


     
     /* const url = page === 1 ? '/tax/v1/group/' : `/tax/v1/group/?page=${page}`;*/
      let url = page === 1 ? `/tax/v1/group/?&page_size=${this.state.entriesPerPage}` : `/tax/v1/group/?page=${page}&page_size=${this.state.entriesPerPage}`;
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      API.get(url)

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;
          if(data.status == true ){
            const { data: posts, pagination } = data;
            const perPage = Math.ceil(pagination.count / pagination.total_pages);

            // Calculate startIndex and endIndex based on pagination data
            const startIndex = (pagination.current_page - 1) * perPage + 1;
            const endIndex = Math.min(pagination.current_page * perPage, pagination.count);
            console.log("Start Index", pagination.showing.start, 'End Index',pagination.showing.end )


           this.setState({posts: data.data, currentPage: pagination.current_page,
            totalPages: pagination.total_pages, totalItems: pagination.count,
            startIndex: startIndex,perPage: perPage,
            endIndex: endIndex,startCount: pagination.showing.start, endCount: pagination.showing.end })
          }else{
            this.setState({posts: [],  totalPages: 1,
            currentPage: 1,
            startIndex: 0,
            endIndex: 0,
            totalItems: 0,
            startCount: 0,
            endCount: 0})
          }

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log('endCount',this.state.endCount, 'startCount', this.state.startCount);

      });
  }

   handlePageChange(pageNumber) {
    this.fetchBinData(pageNumber);
  }

  downloadExcel = async () => {
    this.setState({ isDownloading: true });
    const token = Util.accessCookie("token");
    let url = `${base_url}/tax/v1/group/download/`;
    
    // Append brand parameter only if it exists
    if (this.state.brand) {
        url += `?brand=${this.state.brand}`;
    }
    if (this.state.searchTerm) {
        url += `?search=${this.state.searchTerm}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "tax_master_report.csv"); // Set filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
       this.setState({ isDownloading: false });
    } catch (error) {
      console.error("Error downloading file:", error);
       this.setState({ isDownloading: false });
    }
  };



 
 

  assemblePosts= () => {
    

    let posts =this.state.posts.map((post) => {

      return (

        {
          // Warehouse: post.warehouse,
          // brand: post.brand,

          tax_type: post.tax_type.tax_type,

          tax_community: post.tax_community.name,
          tax_group: post.tax_group.group,
         /* desc: post.tax_group.description,*/
           desc: (
          <div className="text-wrap-cell">
            {post.tax_group.description}
          </div>
        ),
          action:  <Button
                    className="white_bckgrd_button "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#fff",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      float: 'left',
                      color: this.state.enableCreateCycle === true ? '#fff': "black",
                    }}
                    id="white_bckgrd_button"
                     disabled= {this.state.enableCreateCycle}
                      onClick={()=> this.viewItem(post.tax_group.group)}
                  >
                    {this.state.genloading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                     
                    View Items 
                  </Button>


          // ranking: post.ranking,

          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }


 
 
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;
    const { tableRows, currentPage, totalPages, totalItems, startIndex, endIndex, loading_overlay } = this.state;


    const data = {

      columns: [

        {

          label:'Tax Type',

          field:'tax_type',
          sort: '',
          width: 120

        },

        {

          label:'Tax Community',

          field:'tax_community',
          sort: '',
          width: 190

        },
        {

          label:'Tax Group',

          field:'tax_group',
          sort: '',
          width: 170,

          width: 170
        },
        {

          label:'Desc',

          field:'desc',
          sort: '',
          width: 290

        },

        {

          label:'',

          field:'action',
          sort: 'disabled',
          width: 150


        },
       


        

      ],

      rows:this.state.tableRows,

    }


   

    return (
      <Col xl={12}>
         {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
            <div
                className="form__form-group"
                style={{ display: "inline-flex", marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "block" }}
                >
                 

                     <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      backgroundColor: this.state.enableCreateCycle === true ? '#c1c1c1': "#FBBB00",
                      color: this.state.enableCreateCycle === true ? '#fff': "black",
                    }}
                    id="button_view"
                     disabled= {this.state.enableCreateCycle}
                      onClick={this.createTaxGroup}
                  >
                    {this.state.genloading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                     <img
                        src={PlusIcon}
                        alt="Plus"
                        style={{ width: '17px', marginRight: 6 }} // Adjust size as needed
                    />
                     Create New Tax Group
                  </Button>
                   <Button
                    className="white_bckgrd_button "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#fff",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      float: 'right',
                      color: this.state.enableCreateCycle === true ? '#fff': "black",
                    }}
                    id="white_bckgrd_button"
                     disabled= {this.state.enableCreateCycle}
                      onClick={this.viewMappedItem}
                  >
                    {this.state.genloading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                     
                    View All Mapped Items
                  </Button>
                 
                </div>
              </div>
          {
            this.state.showFetchBinData  && (

              <div id="masterTableContainer" className="taxmaster_table">
            
               
              <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '75%', float: 'left', marginTop: 5 }}>
                <span style={{ marginRight: '0.5rem' }}>Show</span>
                <select
                  id="showEntriesSelect"
                  value={this.state.entriesPerPage}
                  style={{height: 28}}
                  onChange={(e) => {
                    const newLimit = parseInt(e.target.value, 10);
                    this.setState({ entriesPerPage: newLimit }, () => {
                      this.fetchBinData(1); // Reset to page 1 when changing page size
                    });
                  }}
                  style={{ marginRight: '0.5rem' }}
                >
                  {[10, 25, 50, 100].map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </select>
                <span>entries</span>
              </div>
               <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '25%', float: 'left' }}>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search"
                  value={this.state.searchTerm}
                  onChange={this.handleSearchInput}
                  onKeyDown={this.handleKeyDown}
                />
                {this.state.isDownloading ? (
                        <a
                          className="pull-right"
                          style={{
                            fontSize: "17px",
                            paddingRight: "0px",
                            cursor: "pointer",
                            color: "#919193",
             
                            marginLeft: 6
                          }}
                        >
                         
                            <FontAwesomeIcon icon={faSpinner} spin />
                          </a>
                          ) : (
                          <a
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault(); // prevent default anchor behavior
                            this.downloadExcel();
                          }}
                          className="pull-right"
                          style={{
                            fontSize: "17px",
                            paddingRight: "0px",
                            cursor: "pointer",
                            color: "#919193",
            
                            marginLeft: 6
                          }}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                          </a>

                          )}
                {/*<span
                  className="pull-right"
                  onClick={() => exportToCSV(this.state.posts, "AreaMaster", Heading)}
                   style={{
                    fontSize: "17px",
                    paddingRight: "0px",
                    cursor: "pointer",
                    color: "#919193",
                    marginLeft: 6
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>*/}
              </div>
              

            
                <MDBDataTable
                striped
                bordered
                sortable={true}
                searching={false}
                scrollX
                hover
                data={data}
                paging={false}
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
              />

             {/* <div className="pagination-container1">
                <button
                  onClick={() => this.handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="pagination-btn"
                >
                  <i className="fas fa-arrow-left"></i> 
                </button>
                
                <span>{`Page ${currentPage} of ${totalPages}`}</span>
                
                <button
                  onClick={() => this.handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="pagination-btn"
                >
                  <i className="fas fa-arrow-right"></i> 
                </button>
              </div>*/}

              <div className="pagination-container1" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem' }}>
                <div className="pagination-left">
                  <span>Showing {this.state.startCount} to {this.state.endCount} out of {totalItems}</span>
                </div>

                <div className="pagination-right" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {/* First */}
                  <img
                    src={FirstPage}
                    alt="firstPage"
                    style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(1)}
                  ></img>

                  {/* Previous */}
                  <img
                    src={ShapeLeft}
                    alt="Previous"
                    style={{ width: '12px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(currentPage - 1)}
                  />

                  {/* Page Numbers */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => {
                    if (
                      pageNum === 1 ||
                      pageNum === totalPages ||
                      (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                    ) {
                      return (
                        <span
                          key={pageNum}
                          onClick={() => this.handlePageChange(pageNum)}
                          style={{
                            fontWeight: currentPage === pageNum ? 'bold' : 'normal',
                            color: currentPage === pageNum ? '#FBBB00' : '#000',
                            cursor: 'pointer'
                          }}
                        >
                          {pageNum}
                        </span>
                      );
                    } else if (
                      pageNum === currentPage - 3 ||
                      pageNum === currentPage + 3
                    ) {
                      return <span key={pageNum}>...</span>;
                    } else {
                      return null;
                    }
                  })}

                  {/* Next */}
                  <img
                    src={ShapeRight}
                    alt="Next"
                    style={{ width: '12px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(currentPage + 1)}
                  />

                  {/* Last */}
                  <img
                    src={LastPage}
                    alt="lastPage"
                    style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(totalPages)}
                  ></img>
                </div>
              </div>


            </div>

          )}
        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

      


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(TaxMaster));